import { IGetComparisonDesktopResponse } from '../../repositories/offers-comparison/v2/get-comparison-desktop';
import { IState } from '../../store';

export const getOffersComparison = (state: IState): IGetComparisonDesktopResponse | null => {
  return state.comparison.comparison;
};
